var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonConverter, JsonElementType, JsonObject, JsonProperty, OnDeserialized, } from 'ta-json-x';
import { JsonStringConverter } from '../../converters/string-converter';
import { BelongsTo } from './belongs-to';
import { Contributor } from './contributor';
import { Subject } from './subject';
import { Properties } from './properties';
import { MediaOverlay } from './media-overlay';
let Metadata = class Metadata {
    _OnDeserialized() {
        /* istanbul ignore next */
        if (!this.title) {
            console.log('Required [Metadata.Title] is not set!');
        }
    }
};
__decorate([
    JsonProperty('@type'),
    __metadata("design:type", String)
], Metadata.prototype, "type", void 0);
__decorate([
    JsonProperty('identifier'),
    __metadata("design:type", String)
], Metadata.prototype, "identifier", void 0);
__decorate([
    JsonProperty('title'),
    __metadata("design:type", Object)
], Metadata.prototype, "title", void 0);
__decorate([
    JsonProperty('subtitle'),
    __metadata("design:type", Object)
], Metadata.prototype, "subtitle", void 0);
__decorate([
    JsonProperty('modified'),
    __metadata("design:type", Date)
], Metadata.prototype, "modified", void 0);
__decorate([
    JsonProperty('published'),
    __metadata("design:type", Date)
], Metadata.prototype, "published", void 0);
__decorate([
    JsonConverter(JsonStringConverter),
    JsonProperty('language'),
    JsonElementType(String),
    __metadata("design:type", Array)
], Metadata.prototype, "language", void 0);
__decorate([
    JsonProperty('sortAs'),
    __metadata("design:type", String)
], Metadata.prototype, "sortAs", void 0);
__decorate([
    JsonProperty('author'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "author", void 0);
__decorate([
    JsonProperty('translator'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "translator", void 0);
__decorate([
    JsonProperty('editor'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "editor", void 0);
__decorate([
    JsonProperty('artist'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "artist", void 0);
__decorate([
    JsonProperty('illustrator'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "illustrator", void 0);
__decorate([
    JsonProperty('letterer'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "letterer", void 0);
__decorate([
    JsonProperty('penciler'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "penciler", void 0);
__decorate([
    JsonProperty('colorist'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "colorist", void 0);
__decorate([
    JsonProperty('inker'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "inker", void 0);
__decorate([
    JsonProperty('narrator'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "narrator", void 0);
__decorate([
    JsonProperty('contributor'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "contributor", void 0);
__decorate([
    JsonProperty('publisher'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "publisher", void 0);
__decorate([
    JsonProperty('imprint'),
    JsonElementType(Contributor),
    __metadata("design:type", Array)
], Metadata.prototype, "imprint", void 0);
__decorate([
    JsonProperty('readingProgression'),
    __metadata("design:type", String)
], Metadata.prototype, "readingProgression", void 0);
__decorate([
    JsonProperty('description'),
    __metadata("design:type", String)
], Metadata.prototype, "description", void 0);
__decorate([
    JsonProperty('duration'),
    __metadata("design:type", Number)
], Metadata.prototype, "duration", void 0);
__decorate([
    JsonProperty('numberOfPages'),
    __metadata("design:type", Number)
], Metadata.prototype, "numberOfPages", void 0);
__decorate([
    JsonProperty('belongsTo'),
    __metadata("design:type", BelongsTo)
], Metadata.prototype, "belongsTo", void 0);
__decorate([
    JsonProperty('subject'),
    JsonElementType(Subject),
    __metadata("design:type", Array)
], Metadata.prototype, "subject", void 0);
__decorate([
    JsonProperty('rendition'),
    __metadata("design:type", Properties)
], Metadata.prototype, "rendition", void 0);
__decorate([
    JsonProperty('source'),
    __metadata("design:type", String)
], Metadata.prototype, "source", void 0);
__decorate([
    JsonConverter(JsonStringConverter),
    JsonProperty('epub-type'),
    JsonElementType(String),
    __metadata("design:type", Array)
], Metadata.prototype, "epubType", void 0);
__decorate([
    JsonProperty('rights'),
    __metadata("design:type", String)
], Metadata.prototype, "rights", void 0);
__decorate([
    JsonProperty('media-overlay'),
    __metadata("design:type", MediaOverlay)
], Metadata.prototype, "mediaOverlay", void 0);
__decorate([
    OnDeserialized(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Metadata.prototype, "_OnDeserialized", null);
Metadata = __decorate([
    JsonObject()
], Metadata);
export { Metadata };
//# sourceMappingURL=metadata.js.map